const KEY = 'if-discovery-session-v1';

export function peekDiscoverySessionId() {
  if (typeof window === 'undefined') return null;
  try {
    return sessionStorage.getItem(KEY);
  } catch (_) {
    return null;
  }
}

export function clearDiscoverySessionId() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(KEY);
  } catch (_) {
    /* ignore */
  }
}

/** Drop the current id and mint a fresh one for a new citizen request. */
export function startNewDiscoverySessionId() {
  clearDiscoverySessionId();
  return getDiscoverySessionId();
}

/** Point the browser at an existing discovery session (restore from history). */
export function setDiscoverySessionId(sessionId) {
  const id = String(sessionId || '').trim();
  if (!id || typeof window === 'undefined') return null;
  try {
    sessionStorage.setItem(KEY, id);
    return id;
  } catch (_) {
    return null;
  }
}

export function getDiscoverySessionId() {
  if (typeof window === 'undefined') return null;
  try {
    let id = sessionStorage.getItem(KEY);
    if (!id) {
      id = `ds_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(KEY, id);
    }
    return id;
  } catch (_) {
    return null;
  }
}

export async function trackDiscovery(event, {
  packageId, portalId, meta,
} = {}) {
  const { trackDiscoveryEventApi } = await import('../api/applicationType.api.js');
  return trackDiscoveryEventApi({
    event,
    packageId: packageId || null,
    portalId: portalId || null,
    host: typeof window !== 'undefined' ? window.location.host : null,
    sessionId: getDiscoverySessionId(),
    meta: meta || {},
  });
}
